<template>
  <div
    class="card-body col-8 pt-0 p-3 mx-auto"
    style="cursor: pointer"
    @click="$emit('line-card-clicked', lineId)"
  >
    <ul class="list-group">
      <li
        class="list-group-item border-0 d-flex flex-wrap p-3 mb-1 border-radius-lg align-items-center justify-content-between"
        style="background-color: rgb(230, 230, 230); cursor: pointer"
      >
        <div class="col p-2">
          <span class="text-lg">
            {{ $t("Line Name") }}
          </span>
          <div
            onmouseover="style.textDecoration = 'underline'"
            onmouseout="style.textDecoration = 'none'"
          >
            <h6 class="text-2xl">{{ lineName }}</h6>
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row align-items-center ms-auto gap-4">
          <div class="text-end">
            <span class="text-xs">
              {{ $t("Created") }}
            </span>
            <div class="my-auto">
              <p style="font-size: 0.8rem">
                <b>{{ dateTime }}</b>
              </p>
            </div>
          </div>
          <div
            v-if="!$store.state.finetune_license"
            class="text-end"
            @click.stop="$router.push({ name: 'LineDetailBluePrint', params: { lineId: lineId } })"
          >
            <a
              class="btn btn-link text-dark mb-0 my-auto w-100"
              style="white-space: nowrap;"
            >
              <i
                class="fas fa-pencil-alt text-dark me-2"
                aria-hidden="true"
              ></i>
              {{ $t("Edit") }}
            </a>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "LineCardBluePrintFineTune",
  props: {
    lineName: {
      type: String,
      default: "",
    },
    lineId: {
      type: String,
      default: "",
    },
    dateTime: {
      type: String,
      default: "",
    },
  },
  emits: ["line-card-clicked"],
  data() {
    this.$i18n.locale = this.$store.state.user_data.language;
    return {
      gunsEqualizationId: "",
    };
  },
  methods: {},
};
</script>
<i18n>
  {
    "EN": {
        "Line Name":"Line Name",
        "Created":"Created",
        "Edit":"Edit",
    },
    "DE": {
        "Line Name":"Linienname",
        "Created":"Erstellt",
        "Edit":"Bearbeiten",
    },
    "ES": {
        "Line Name":"Nombre de la Línea",
        "Created":"Creada",
    },
    "FR": {
        "Line Name":"Nom de la Ligne",
        "Created":"Créée",
        "Edit":"Modifier",
    },
    "IT": {
        "Line Name":"Nome della Linea",
        "Created":"Creata",
        "Edit":"Modifica",
    },
    "PL": {
        "Line Name":"Nazwa Linii",
        "Created":"Utworzony",
        "Edit":"Edytuj",
    },
    "TR": {
        "Line Name":"Hat İsmi",
        "Created":"Oluşturuldu",
        "Edit":"Düzenle",
    },
    "ZH": {
        "Line Name":"线路名称",
        "Created":"创建",
        "Edit":"编辑"
    },
  }
</i18n>
